module.exports = __webpack_public_path__ + "img/caredo-logo.35ea0467.svg";